// noinspection JSUnusedGlobalSymbols
export enum TyroPayRequestStatus {
    AWAITING_PAYMENT_INPUT = "AWAITING_PAYMENT_INPUT",
    AWAITING_AUTHENTICATION = "AWAITING_AUTHENTICATION",
    PROCESSING = "PROCESSING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    VOIDED = "VOIDED",
    PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
    REFUNDED = "REFUNDED"
}

// noinspection JSUnusedGlobalSymbols
export class TyroPayRequest {
    capture: {
        method: string;
    };
    gatewayCode: string;
    isLive: boolean;
    origin: {
        orderId: string;
    };
    status: TyroPayRequestStatus;
    supportedNetworks: string[];
    threeDSecure: {
        status: string;
    };
    total: {
        amount: number;
        currency: string;
    };
    vgsRoutePrefix: string;
}

// noinspection JSUnusedGlobalSymbols
export enum TyroPayRequestErrorType {
    CLIENT_VALIDATION_ERROR = "CLIENT_VALIDATION_ERROR",
    SERVER_VALIDATION_ERROR = "SERVER_VALIDATION_ERROR",
    CARD_ERROR = "CARD_ERROR",
    SERVER_ERROR = "SERVER_ERROR",
    UNKNOWN_ERROR = "UNKNOWN_ERROR"
}

export class TyroPayRequestError {
    type: TyroPayRequestErrorType;
    errorMessage: string;
    errorCode: string;
    gatewayCode: string;
}